import { createElement } from "react";

import {
    ApiBlueprint,
    createApiFactory,
    createFrontendPlugin,
    discoveryApiRef,
    identityApiRef,
    PageBlueprint,
} from "@backstage/frontend-plugin-api";
import { FirefighterClient } from "@internal/backstage-plugin-firefighter-common";
import { firefighterApiRef } from "@internal/backstage-plugin-firefighter-react";

import { pluginId, rootRouteRef } from "./routes";

export const FirefighterPage = PageBlueprint.make({
    params: {
        path: "/firefighter",
        routeRef: rootRouteRef,
        title: "Firefighter",
        loader: async () => {
            const { FirefighterPage: Page } = await import(
                "./views/FirefighterPage"
            );
            return createElement(Page);
        },
    },
});

export const firefighterApiFactory = createApiFactory({
    api: firefighterApiRef,
    deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
    },
    factory: ({ discoveryApi, identityApi }) =>
        new FirefighterClient({ discoveryApi, identityApi }),
});

const firefighterApiExtension = ApiBlueprint.make({
    name: pluginId,
    params: defineParams => defineParams(firefighterApiFactory),
});

export const firefighterPlugin = createFrontendPlugin({
    pluginId,
    routes: { root: rootRouteRef },
    extensions: [FirefighterPage, firefighterApiExtension],
});

export default firefighterPlugin;
